/**
 * Check if current device is a touch device
 * @returns {Boolean}
 */
export function isTouchDevice() {
  return window && window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
}

/**
 * Return a value bettween min an max
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
export function getMinMax(value = 0, min = 0, max = Infinity) {
  let newValue = value;
  newValue = Math.max(newValue, min);
  newValue = Math.min(newValue, max);
  return newValue;
}

/**
 * function makes sure that your code is only triggered once per user input
 * @param {function} action
 * @param {number} delay in ms (default 200ms)
 * @returns {function}
 */
export function debounce(action, delay) {
  let timeout;
  return (...args) => clearTimeout(timeout, setTimeout(action, delay, ...args));
}